import React from 'react';
import ReactDOM from 'react-dom'
import './assets/scss/custom.scss';
import App from './app/App';
import { Provider } from 'react-redux';
import store, { persistor } from './setup/redux/Store';
import { PersistGate } from 'redux-persist/integration/react';

const { PUBLIC_URL } = process.env

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
          <App basename={PUBLIC_URL} />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)
